import img from "../assets/img/img.jpeg";

import jpg1 from "../assets/img/JPG/2 Jazyk.jpg";
import jpg2 from "../assets/img/JPG/1 Licka.jpg";
import jpg3 from "../assets/img/JPG/3 Hovezi krk vcelku.jpg";
import jpg3a from "../assets/img/JPG/3 a Hovezi krk rozbourany.jpg";
import jpg4 from "../assets/img/JPG/4 Hrudi.jpg";
import jpg5 from "../assets/img/JPG/5 Podpleci.jpg";
import jpg6 from "../assets/img/JPG/6 Vysoky rostenec steaky 2.jpg";
import jpg6a from "../assets/img/JPG/6a Vysoky rostenec Rib eye steak tomahawk.jpg";
import jpg7 from "../assets/img/JPG/7 Kulata plec - falesna svickova ocistena.jpg";
import jpg8 from "../assets/img/JPG/8 loupana plec (top blade vcelku).jpg";
import jpg8a from "../assets/img/JPG/8b Loupana plec (flat iron steak 2).jpg";
import jpg8b from "../assets/img/JPG/8a loupana plec (top blade steaky).jpg";
import jpg9 from "../assets/img/JPG/9 Velka plec ocistena.jpg";
import jpg10 from "../assets/img/JPG/10 - husicka s predni klizkou.jpg";
import jpg10a from "../assets/img/JPG/10 Husicka rozbourana ocistena.jpg";
import jpg11 from "../assets/img/JPG/11 Predni klizka vcelku.jpg";

import jpg12 from "../assets/img/JPG/12 Zebro vysoke 1.jpg";
import jpg13 from "../assets/img/JPG/13 hovezi zebro hole.jpg";
import jpg14 from "../assets/img/JPG/14 oponka.jpg";
import jpg15 from "../assets/img/JPG/15 veverka - hanger steak.jpg";
import jpg16 from "../assets/img/JPG/16 nizky rostenec vcelku.jpg";
import jpg16a from "../assets/img/JPG/16a porterhouse + T-bone steak.jpg";
import jpg17 from "../assets/img/JPG/17 svickova vcelku.jpg";
import jpg17a from "../assets/img/JPG/17a svickova naporcovana 2.jpg";
import jpg18 from "../assets/img/JPG/18 zebro nizke.jpg";
import jpg19 from "../assets/img/JPG/19  flank steak.jpg";
import jpg20 from "../assets/img/JPG/20 flap steak.jpg";
import jpg21 from "../assets/img/JPG/21 holubicka.jpg";
import jpg21a from "../assets/img/JPG/21a picanha-s-tukovym-krytim.jpg";
import jpg21b from "../assets/img/JPG/21 holubicka mamina.png";
import jpg22 from "../assets/img/JPG/22 orech.jpg";
import jpg23 from "../assets/img/JPG/23 kvetova spicka.jpg";
import jpg24 from "../assets/img/JPG/24 tabulova spicka.jpg";
import jpg25 from "../assets/img/JPG/25 spodni sal.jpg";
import jpg26 from "../assets/img/JPG/26 vrchni sal.jpg";
import jpg27 from "../assets/img/JPG/27 valecek na rezu.jpg";
import jpg28 from "../assets/img/JPG/28 karabacek.jpg";
import jpg29 from "../assets/img/JPG/29 zadni klizka.jpg";
import jpg29a from "../assets/img/JPG/11 a Klizka s kosti + nakrajene platky osso bucco.jpg";
import jpg30 from "../assets/img/JPG/30 ohanka.jpg";

export const textyZakladni = {
  text: [
    {
      id: "Jazyk",
      name: "Jazyk",
      textSvis:
        "Jazyk se již dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },

    {
      id: "Licka",
      name: "Líčka",
      textSvis:
        "Líčka se již dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },
    {
      id: "Krk",
      name: "Krk",
      textSvis:
        "Krk se již dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },

    {
      id: "Hrudi",
      name: "Hrudí",
      textSvis:
        "Hrudí se již dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },
    {
      id: "VRostenec",
      name: "Vysoký roštěnec",
      textSvis:
        "Vysoký roštěnec se dále dělí na Podplečí a Vysoký roštěnec. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "Plec",
      name: "Plec",
      textSvis:
        "Plec se dále dělí na Kulatá Plec - falešná svíčková, Loupaná plec a Velká plec. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "PKlizka",
      name: "Přední kližka",
      textSvis:
        "Přední kližka se dále dělí na Husičku a Přední kližku. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "PZebro",
      name: "Přední žebro",
      textSvis:
        "Přední žebro se dále dělí na Vysoké žebro a Holé žebro. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "Veverka",
      name: "Veverka",
      textSvis:
        "Veverka se již dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },
    {
      id: "Oponka",
      name: "Oponka",
      textSvis:
        "Oponka se již dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },
    {
      id: "NRostenec",
      name: "Nízký Roštěnec",
      textSvis:
        "Nízký roštěnec je součástí hřbetu s kostí, který dále obsahuje Svíčkovou. V případě, že hřbet necháme vcelku s kosí, můžeme z něj nařezat podélně od zadní části Porterhouse a T-bone steaky. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "Svickova",
      name: "Svíčková",
      textSvis:
        "Svíčková se dále dělí na palec, kterému se také říká Chateaubriand. Vedle palce se nachází střed, ze kterého se připravují hovězí steaky nebo také Tournedos.  Z části, která se již zužuje se přiravují medajlonky nebo také Filet Mignon. Z konců svíčkové se přiravuje Tatarský biftek nebo Carpaccio. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "BokSKosti",
      name: "Bok s kostí",
      textSvis:
        "Bok s kostí se dále nedělí a vytěžuje se z něj Nízké žebro. Pro fotky a bližší informace klikněte na Kompletní zobrazení. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "BokBezKosti",
      name: "Bok bez kosti",
      textSvis:
        "Bok bez kosti se dále dělí na Pupek - Flank steak nebo také Zrcátko a na Pupek - Flap steak nebo také Bryndáček. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "Kyta",
      name: "Kýta",
      textSvis:
        "Kýta se dále dělí na Ořech, Holubičku, Květovou špičku, Tabulovou špičku, Spodní šál, Vrchní šál a Váleček. Pro fotky a bližší informace klikněte na Kompletní zobrazení.",
    },
    {
      id: "ZKlizka",
      name: "Zadní kližka",
      textSvis:
        "Zadní kližka se dále dělí na Kližku a Karabáček. Pro fotky a bližší informace klikněte na Kompletní zobrazení. ",
    },
    {
      id: "Ohanka",
      name: "Oháňka",
      textSvis:
        "Oháňka se dále nedělí, pro fotku a bližší informace klikněte na kompletní zobrazení.",
    },
  ],
};

export const textyKompletni = {
  text: [
    {
      id: "Jazyk",
      name: "Jazyk",
      img: jpg1,
      textSvis:
        "Jazyk je tuhý ale velmi libový sval, který vyžaduje pomalé a dlouhé dušení, aby změkl. ",
      // textVod:'ahojojjojoj'
    },

    {
      id: "Licka",
      name: "Líčka",
      img: jpg2,
      textSvis:
        "Líčka jsou velmi namáhaným a prokrveným svalem. Jedná se o libové maso, mají jemná svalová vlákna, jemný kolagem a hodí se hlavně pro pomalé dušení. ",
      textVod: null,
    },
    {
      id: "Krk",
      name: "Krk",
      img: jpg3,
      img2: [jpg3a],
      textSvis:
        "Krk neboli Chuck je velký sval, který má vcelku, dle velikosti býka okolo 5 kg a více. Celý krk můžeme rozbourat na 8 jednotlivých částí. V případě, že je maso z býka nebo jalovice dostatečné stařené, dají se z válcovitých částí krku připravit steaky. Krk je vhodný na mletí do burgerů nebo na pomalé dušení a pečení. ",
      textVod: "Krk rozbouraný na 8 jednotllivých částí",
    },
    {
      id: "Hrudi",
      name: "Hrudí",
      img: jpg4,
      textSvis:
        "Hrudí je další velký a libový sval, který se nejčastěji používá na pomalé dušení, pečení a uzení. Hudí také najdete pod názvem Brisket, což je část nejčastěji používaná jako trhané maso.",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Podpleci",
      name: "Podplečí",
      img: jpg5,
      textSvis:
        "Podplečí neboli péro je část, která spojuje krk a vysoký roštěnec. Jedná se o libové maso, které je vhodné na pomalé dušení a pečení. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "VRostenec",
      name: "Vysoký Roštěnec",
      img: jpg6,
      img2: [jpg6a],
      textSvis:
        "Vysoký roštěnec je u vyzrálého masa (býka, jalovice) velmi ceněné steakové maso, které se nejlépe hodí na grilování a opékání. Steak z vysokého roštěnce ja také nazývaný Rib eye díky středové libové části. Chuťově je to jedno z nejvýraznějších steakových mas. V případě krávy je vysoký roštěnec spíš vhodný pro dušení a pečení. ",
      textVod:
        "Steak z vysokého roštěnce s kostí, kterému se říká díky svému tvaru Tomahawk.",
    },
    {
      id: "KPlec",
      name: "Kulatá plec - falešná svíčková",
      img: jpg7,
      textSvis:
        "Kulaté pleci se také říká falešná svíčková, je to velmi libové maso s jemným vláknem. Není to ale steakové maso. Hodí se spíše na dušení, vaření a pečení. Nejčastější je asi příprava svíčkové na smetaně s knedlíkem. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "LPlec",
      name: "Loupaná plec",
      img: jpg8,
      img2: [jpg8a, jpg8b],
      textSvis:
        "Loupaná plec je typická svou šlachou, která prochází středem celého svalu. Zbytek svalu je velmi libové maso. V příadě krávy nebo nevyzrálého masa se hodí k dušení, vaření nebo pomalému pečení. ",
      textVod:
        "V případě dostatečně vyzrálého masa s mramorováním z býka nebo jalovice můžeme z tabulové špičky odstanit podélným řezem šlachu, čímž získáme ceněné steakové maso zvané Top blade a Flat iron, které má výraznou hovězí chuť. ",
    },
    {
      id: "VPlec",
      name: "Velká plec",
      img: jpg9,
      textSvis:
        "Velká plec je nejjemnější část celé plece. Hodí se k pečení a dušení  vcelku, na kostky nebo na plátky například na rolády nebo ptáčky. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Husicka",
      name: "Husička",
      img: jpg10,
      img2: [jpg10a],
      textSvis:
        "Husička je horní část přední kližky, která je libovější a méně prorostlá, než kližka somatná. Velmi vhodná část na dušení a na guláš. ",
      textVod: "Celá husička rozbouraná na jednotlivé části. ",
    },
    {
      id: "KPredni",
      name: "Kližka přední",
      img: jpg11,

      textSvis:
        "Přední kližka bez kosti je šlachovitý sval, jehož vnitřní maso je ale jemné a šťavnaté. Proto se hodí k dušení a na guláš. ",
      //textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "VZebro",
      name: "Žebro Vysoké",
      img: jpg12,
      textSvis:
        "Vysoké žebro obsahuje 1.  8. žebro, maso je prorostlé a také díky kosti zůstává při dušení a pečení velmi šťavnaté. Díky obsahu kosti a kolagenu je velmi vhodné na přípravu polévkových vývarů. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "ZHole",
      name: "Žebro Holé",
      img: jpg13,
      textSvis:
        "Holé žebro neobsahuje tolik masa, ale díky obsahu žeberních kostí je velmi vhodné na vývary a polévky",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Oponka",
      name: "Oponka",
      img: jpg14,
      textSvis:
        "Oponka neboli Skirt steak je další sval, který drží a napíná bránici v hrudním koši. Je to jemné maso se silným vláknem, které je v případě dostatečné vyzrálosti u býka a jalovice velmi žádaným steakovým masem ceněným mezi milovníky hovězího steakového masa. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Veverka",
      name: "Veverka",
      img: jpg15,
      textSvis:
        "Veverka je prokrvený sval, který je součástí bránice a leží u špičky svíčkové. Veverka se také nazývá Hanger steak a v případě, že se jedná o býka nebo jalovici a maso je dostatečně vyzrále, je to velmi kvalitní steakové maso s jemným mramorováním a výraznou hovězí chutí. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "NRostenec",
      name: "Nízký Roštěnec",
      img: jpg16,
      img2: [jpg16a],
      textSvis:
        "Nízký roštěnec je jedno z nejznámnějších steakových mas. Mý výrazné tukové krytí na povrchu a uvnitř svalu je libové s případným mramorováním, které určuje kvalitu a chuť masa. Je to část masa, která je vhodná jak na pečení vcelku, například jako známý Roastbeef. Velmi často se používá jako stakové maso známe jako Striploin steak. ",
      textVod:
        "V případě, že na hřbetu s kostí zachováme nízký roštěnec a svíčkovou, můžeme kolmo ke kosti a od zadní části začít krájet dva druhy velmi ceněných steaků. První dva řezy (záleží na tloušťce, většinou cca 3 cm) obsahují velkou část svíčkové a vedle nízkého roštěnce také květovou špičku neboli Rumpsteak. Těmto velmi ceněným steakům se říká Porterhouse steak. Další řezy kolmo ke kosti obsahující svíčkovou a nízký roštěnec se nazývají T-bone steak. ",
    },
    {
      id: "Svickova",
      name: "Svíčková",
      img: jpg17,
      img2: [jpg17a],
      textSvis:
        "Hovězí svíčková neboli Beef Tenderloin je asi nejznámnější steakové maso. Je to nejjemnější maso z celého býka, ale na druhou stranu nemá tolik chuti jako například Nízký nebo Vysoký roštěnec. V celém býkovi, jalovici nebo krávě jsou 2 kusy svíčkové. ",
      textVod:
        "Hovězí svíčková neboli Tenderloin se dále dělí na několik částí. První zprava se nazývá palec, nebo také Chateaubriand. Tato část se připravuje vcelku a filíruje se před zákazníkem. Vedle palce se nachází střed, ze kterého se připravují klasické steaky ze svíčkové. Tato část se také nazývá Tournedos. Z části vedle středu, která se již zúžuje se připravují medajlonky zvané také Filet Mignon. Ze špičky svíčkové se připravuje Tatarský biftek, který by se měl krájet ručně ostrým nožem, nebo tzv. Carpaccio, což jsou velmi tenké plátky svíčkové. ",
    },
    {
      id: "ZNizke",
      name: "Žebro nízké",
      img: jpg18,
      textSvis:
        "Nízké žebro se nachází mezi 9. a 13. žebrem. Vykostěné maso se hodí na rolády a na dušení. Díky obsahu hrudních kostí se také hodí na tažení vývarů a polévek. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "PupekFlank",
      name: "Pupek - Flank steak",
      img: jpg19,
      textSvis:
        "Pupek neboli Flank steak je libové maso se silným vláknem, které se nachzí ve spodní části pupku. V případě krávy a nakrájení na kostky je vhodné na guláše. V případě býka a jalovice a dostatečného zrání je to velmi chutné steakové maso. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "PupekFlap",
      name: "Pupek - Flap steak",
      img: jpg20,
      textSvis:
        "Pupek neboli Flap steak neboli Bavette je libové maso se silným vláknem, které se nachzí v horní části pupku. V případě krávy a nakrájení na kostky je vhodné na guláše. V případě býka a jalovice a dostatečného zrání je to velmi chutné steakové maso. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Holubicka",
      name: "Holubička - Maminha",
      img: jpg21,
      img2: [jpg21b],
      textSvis:
        "Holubička je sval, který spojuje Ořech a Květovou špičku. V případě býka nebo jalovice a dostatečného vyzrání je to kvalitní steakové maso. Hodí se ke grilování nebo pečení nejčastěji vcelku.",
      textVod:
        "Holubička, na které zachováme vysoké tukové krytí se nazývá Maminha. S tímto názvem se setkáme hlavně v Jižní Americe a ve španělsky mluvících zemích. Je to velmi kvalitní stakové maso, které se často griluje nebo peče vcelku s tukovým krytím",
    },
    {
      id: "Orech",
      name: "Ořech",
      img: jpg22,
      textSvis:
        "Ořech je jeden z nejvíce namáhaných svalů kýty a díky svému vysokému obsahu kolagenu se hodí jen k dušení nebo pečení. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "KvetovaSpicka",
      name: "Květová špička - Picanha",
      img: jpg23,
      img2: [jpg21a],
      textSvis:
        "Květová špička neboli Rumpsteak je sval jehož špička na levé části zasahuje do nízkého roštěnce. V případě dostatečného vyzrání u býka nebo jalovice je to žádané steakové maso s výraznou chutí. V případě krávy se spíše hodí k dušení, vaření a pomalému pečení. ",
      textVod: `Květová špička, na které zachováme vysoké tukové krytí se nazývá Picanha. S tímto názvem se setkáme hlavně v Jižní Americe 
      a ve španělsky mluvících zemích. Je to velmi kvalitní stakové maso, které se často griluje nebo peče vcelku s tukovým krytím`,
    },
    {
      id: "TabulovaSpicka",
      name: "Tabulová špička",
      img: jpg24,
      textSvis:
        "Tabulová špička známá také jako Tafelspitz je libové a šťavnaté maso, které se využívá hlavně k dušení, vaření a přípravě silných vývarů",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "VrchniSal",
      name: "Spodní šál",
      img: jpg26,
      textSvis:
        "Spodní šál je velmi libové a prokrvené maso s tmavou barvou a výraznou chutí, které se hodí na pomalé dušení, pečení nebo vaření.",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "SpodniSal",
      name: "Vrchní šál",
      img: jpg25,
      textSvis:
        "Vrchní šál je libové maso s hrubšími vlákny, které se hodí k dušení. Nakrájené na plátky se často používá na přípravu ptáčků. V případě mladého nebo vyzrálého býka nebo jalovice se dá také použít na pečení, například roastbeef. ",

      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Valecek",
      name: "Váleček",
      img: jpg27,
      textSvis:
        "Váleček má podle svého názvu tvar úhledného válce. Je velmi libové ale je to jedno z nejtužších částí hovězího masa a proto se hodí hlavně k pomalému dušení, pečení a vaření. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Karabacek",
      name: "Karabáček",
      img: jpg28,
      textSvis:
        "Karabáček je horní část zadní kližky, má libové maso s menším obsahem šlach ve srovnání s ostatními kližkami a proto se hodí k pomalému dušení a vaření, je to typické maso na guláš. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
    {
      id: "Klizka",
      name: "Kližka - zadní",
      img: jpg29,
      img2: [jpg29a],
      textSvis:
        "Zadní kližka má více libové maso s menším obsahem šlach ve srovnání s přední kližkou. Je také vhodná na pomalé dušení a vaření. ",
      textVod:
        "V případě, že v zadní kližce necháme kost a naporcujeme ji kolmo ke kosti, získáme tvz. Osso buco, což je maso plné chuti vhodné hlavně pro pomalé dušení. ",
    },
    {
      id: "Ohanka",
      name: "Oháňka",
      img: jpg30,
      textSvis:
        "Oháňka je jedno z nejvhodnějších části na přípravu silných masových vývarů a polévek díky vysokému obsahu kolagenu v kostech. Aby se kolagen lépe uvolnil do vývaru je potřeba oháňku nakrájet a odhalit tak jednotlivé obratle. ",
      // textVod: 'asjhdajhakhdsakjhasdkashkashdkh'
    },
  ],
};
